import { render, staticRenderFns } from "./CreatorRecieveMoney.vue?vue&type=template&id=90a56bc0&"
import script from "./CreatorRecieveMoney.vue?vue&type=script&lang=js&"
export * from "./CreatorRecieveMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports